<template>
  <div class="flex space-x-4 mt-4 mb-4">
    <div
      @click="model = 'yes'"
      :class="{
        'bg-primary text-white': model === 'yes',
        'opacity-50 pointer-events-none': passed,
      }"
      class="flex h-[160px] w-[160px] cursor-pointer flex-col items-center justify-center rounded-md font-bold text-primary ring-1 ring-primary transition-colors hover:bg-primary hover:text-white"
    >
      <component class="mb-3.5 h-10 w-10" :is="iconSet.yes" />
      <span
        v-if="!context.hide_labels"
        v-text="context.options.yes"
        class="w-full appearance-none bg-transparent text-center text-xl outline-none"
      />
    </div>
    <div
      @click="model = 'no'"
      :class="{
        'bg-primary text-white': model === 'no',
        'opacity-50 pointer-events-none': passed,
      }"
      class="flex h-[160px] w-[160px] cursor-pointer flex-col items-center justify-center rounded-md font-bold text-primary ring-1 ring-primary transition-colors hover:bg-primary hover:text-white"
    >
      <component class="mb-3.5 h-10 w-10" :is="iconSet.no" />
      <span
        v-if="!context.hide_labels"
        v-text="context.options.no"
        class="w-full appearance-none bg-transparent text-center text-xl outline-none"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import {
  IconCheck,
  IconHeart,
  IconHeartOff,
  IconMoodSad,
  IconMoodSmile,
  IconThumbDown,
  IconThumbUp,
  IconX,
} from '@tabler/icons-vue'

const emits = defineEmits(['passed', 'update:model-value'])

const props = defineProps({
  context: {
    type: Object,
  },
  passed: {
    type: Boolean,
  },
  current: {
    type: Boolean,
  },
  modelValue: {
    type: [String],
  },
})

const icons = ref({
  smiles: {
    yes: IconMoodSmile,
    no: IconMoodSad,
  },
  thumbs: {
    yes: IconThumbUp,
    no: IconThumbDown,
  },
  check: {
    yes: IconCheck,
    no: IconX,
  },
  hearts: {
    yes: IconHeart,
    no: IconHeartOff,
  },
})

const iconSet = computed(() => icons.value[props.context.icons])

const model = computed({
  get: () => {
    return props.modelValue ?? []
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})

onMounted(() => {
  document.addEventListener('keypress', function (event) {
    if (props.current && !props.passed) {
      const v = parseInt(event.key)
      if (v && v <= 2) {
        model.value = v === 1 ? 'yes' : 'no'
      }
    }
  })
})
</script>
